import Vue from "vue";
import App from "./App.vue";
// import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import Amplify from "aws-amplify";
import awsExports from "./aws-exports.js";
import "./plugins/quasar";
import { createProvider } from "./vue-apollo";
import * as Sentry from "@sentry/browser";
import { Vue as VueIntegration } from "@sentry/integrations";
import { Integrations } from "@sentry/tracing";


Amplify.configure(awsExports);

Vue.config.productionTip = false;

Sentry.init({
  dsn: "https://0d1aa4d843b04f7fb41bc0d7c9de09fa@o310842.ingest.sentry.io/5457255",
  integrations: [
    new VueIntegration({
      Vue,
      tracing: true,
    }),
    new Integrations.BrowserTracing(),
  ],

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0,
});

new Vue({
  router,
  store,
  apolloProvider: createProvider(),
  render: h => h(App)
}).$mount("#app");
